import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import { BannerNotificationType } from "../../components/SimpleNotification";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function LabSamplesViewModel(logout) {
  const [filters, setFilters] = useState({
    laboratory: { value: -1, label: "All laboratories" },
    startDate: null,
    endDate: null,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [samples, setSamples] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [suppliers, setSuppliers] = useState([]);

  const getSamples = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      filter: filters,
    };
    let callResult = await makePostApiCall(`lab-samples`, payload);
    setLoading(false);
    if (callResult.success) {
      setSamples(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const filterComponents = [
    <DateRangeFilter
      startDate={filters.startDate}
      endDate={filters.endDate}
      onChange={(name, value) =>
        setFilters({
          ...filters,
          [name]: value,
        })
      }
      resetFilter={() =>
        setFilters({
          ...filters,
          startDate: null,
          endDate: null,
        })
      }
    />,
    <FilterSingleSelectDropdown
      header="Supplier"
      onChange={(value) =>
        setFilters({
          ...filters,
          supplier: value,
        })
      }
      options={suppliers}
      resetFilter={() =>
        setFilters({
          ...filters,
          supplier: { value: -1, label: "All suppliers" },
        })
      }
      valueName="supplier"
      value={filters.supplier}
    />,
  ];

  const resetFilters = () => {
    const filterReset = {
      supplier: { value: -1, label: "All suppliers" },
      startDate: null,
      endDate: null,
    };
    setFilters(filterReset);

    setShowFilters(false);
    getSamples(null, 1, filterReset);
  };

  //   const getSuppliers = async function () {
  //     let callResult = await makeGetApiCall(`suppliersForDropdown`);
  //     if (callResult.success) {
  //       setSuppliers(callResult.data);
  //     } else {
  //       if (callResult.errorStatus === 401) {
  //         logout();
  //       }
  //     }
  //   };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  return {
    emptyModal,
    loading,
    setEmptyModelOpen,
    setShowSimpleNotification,
    showSimpleNotification,
    filters,
    resetFilters,
    showFilters,
    setShowFilters,
    filterComponents,
    showErrorModal,
    samples,
    getSamples,
  };
}
